// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import { useSelector } from "react-redux"
import * as TimelineSlice from "../slices/timeline"
import * as UserContextSlice from "../../user-context/slice"
import ActionPaneHeaderWithTimeRows from "./ActionPaneHeaderWithTimeRows"
import { TimeRow } from "generated/wisetime/user/timeline/v4/timeline_pb"

type Props = {
  isTrashView: boolean,
  timeRows: TimeRow.AsObject[],
}

const ActionPaneTimeRowsHeader = ({ isTrashView, timeRows }: Props): React.ReactElement<Props> => {
  const currentSiteId = useSelector(UserContextSlice.selectCurrentSiteId)
  const timeRowsForDate = useSelector(TimelineSlice.selectTimeRowsForActiveDate)
  
  return (
    <ActionPaneHeaderWithTimeRows
      timeRows={timeRows}
      timeRowsForDate={timeRowsForDate}
      currentSiteId={currentSiteId}
      isTrashView={isTrashView}
    />
  )
}

export default ActionPaneTimeRowsHeader
